import { StartEvent } from "../../events";
import { BindRecord } from "./frontend";
import { ItemId, QuizId, Serializer } from "../../model/datasource";

export class SectionFrontend<Z extends QuizId, I extends ItemId> {
	itemIdSerializer: Serializer<I>;
	quizIdSerializer: Serializer<Z>;
	constructor(quiz: Serializer<Z>, item: Serializer<I>) {
		this.itemIdSerializer = item;
		this.quizIdSerializer = quiz;
	}

	getBindStart(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.start'),
			'click',
			element => new StartEvent(element)
		);
	}

	getSectionChart(quiz: Z): HTMLElement {
		return document.querySelector(
			`.test-score[data-quiz='${CSS.escape(this.quizIdSerializer.toString(quiz))}'] .chart`
		);
	}

	toggleStart(element: HTMLElement): void {
		const loading = element.parentElement
			.querySelector('.loading');
		console.log('hiding', element, 'and showing', loading);
		loading.classList.remove('d-none');
		element.classList.add('d-none');
	}
}

